import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ResumeScreen from './screens/ResumeScreen'
import WorkScreen from './screens/WorkScreen'
import ContactScreen from './screens/ContactScreen'
import HomeScreen from './screens/HomeScreen'
import Nav from './components/Nav'

function App() {
    return (
        <BrowserRouter>
            <div className='App'>
                {/* <Nav /> */}
                <Routes>
                    {/* <Route path='/' element={<HomeScreen />} />
                    <Route path='/work' element={<WorkScreen />} />
                    <Route path='/contact' element={<ContactScreen />} /> */}
                    <Route path='/' element={<ResumeScreen />} />
                </Routes>
            </div>
        </BrowserRouter>
    )
}

export default App
